import { SHOW_ERROR, UPLOAD_PHOTO } from '.'
import * as api from '../api'

export type PhotoSide = 'front' | 'back'

/**
 * @param stripeKey Stripe public key
 * @param paymentAccountId Payment account ID for Dasher
 * @param payload Image data to upload to Stripe
 * @param side Front or Back photo identificaiton
 */
export const uploadPhoto = (
  stripeKey: string,
  paymentAccountId: string,
  payload: object,
  side: PhotoSide
) => {
  return async dispatch => {
    try {
      const response = await api.uploadFileToStripe(stripeKey, payload)
      const data = {}
      const key = side.toLowerCase() === 'back' ? 'id_back_file' : 'id_file'
      data[key] = response.id

      const patch = await api.updatePaymentAccount(paymentAccountId, data)
      dispatch({
        type: UPLOAD_PHOTO.SUCCESS,
        payload: { ...response, ...patch },
      })
    } catch (error) {
      dispatch({ type: UPLOAD_PHOTO.FAIL })
      dispatch({ error, type: SHOW_ERROR })
      throw error
    }
  }
}
